import { Controller } from "@hotwired/stimulus"

export default class AddContactController extends Controller {
    static targets = [ 'callsign', 'tags', 'callList', 'callTag' ]

    connect() {
        console.log('AddContactController connected');
    }

    initializeCall(): void {
        const initialValue = 'RED FOX ';
        this.callsignTarget.value = initialValue;
        this.callsignTarget.setSelectionRange(initialValue.length, initialValue.length);
    }

    handleCallsignKeydown(event: KeyboardEvent): void {
        const input = this.callsignTarget;
        const cursorPosition = input.selectionStart;
        const endPosition = input.value.length;

        // If a digit key is pressed and cursor is not at the end, append digit to end instead
        if (/^\d$/.test(event.key) && cursorPosition !== endPosition) {
            event.preventDefault();
            input.value = input.value + event.key;
            input.setSelectionRange(input.value.length, input.value.length);
        }
    }

    addCall(): boolean {
        //TODO: sanitize call sign (ie ensure there is space before numbers
        //TODO: validate call sign
        let callsign = this.callsignTarget.value;
        callsign = callsign.toUpperCase().trim();
        if (false == /^[A-Z]+ ([A-Z]+ )?\d{1,4}$/.test(callsign)) {
            this.callsignTarget.classList.add('is-danger');
            return false;
        } else {
            this.callsignTarget.classList.remove('is-danger')
            const tag = this.createTag(callsign);
            const hiddenField = this.createHiddenField(callsign);
            this.tagsTarget.append(tag);
            this.tagsTarget.append(hiddenField);
            this.initializeCall();
        }
        return true;
    }

    removeCall(): void {
        const tag = event.currentTarget.parentElement;
        tag.remove();
    }

    createHiddenField(call: string): HTMLInputElement {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'callsign[]');
        input.setAttribute('value', call);
        return input;
    }

    createTag(call: string): HTMLElement {
        const span = document.createElement('span');
        span.setAttribute('class', 'tag is-dark m-1');
        span.setAttribute('data-add-contact-target', 'callTag');
        span.innerText = call;
        const button = document.createElement('button');
        button.setAttribute('class', 'delete is-small');
        button.setAttribute('data-action', 'click->add-contact#removeCall:prevent');
        span.append(button);
        return span;
    }

    beforeSubmit(): void {
        if (this.callsignTarget.value !== 'RED FOX ' && false === this.addCall()) {
            event.preventDefault();
        }
    }
}
